<template>
  <div class="outer">
    <div class="inner">
      <!--mescroll滚动区域的基本结构-->
      
        <!--内容...-->
        <div class="bodyList" id="cardList">
          <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" class="mescroll">
          <div class="list_item" v-for="(item,index) in CardList" :key="index" @click="pushCardDetail(item.cardUid)">
            <div class="list_item01 flex flex-between">
              <div class="txt">
                <span>{{item.packageName}}</span>
              </div>
              <div class="price">
                <span>￥{{item.packageAmount}}</span>
              </div>
            </div>
            <div class="list_item02">
              <div class="numTxt">
                <span>{{item.endDate}}后失效</span>
              </div>
            </div>
          </div>
          </mescroll-vue>
        </div>
      
      <!-- 底部 -->
      <div class="bottom">
        <div class="bottomBtn">
          <button @click="toActiveCard">激活实体卡</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApi } from "../../api/index.js";
import MescrollVue from "mescroll.js/mescroll.vue";
export default {
  components: {
    MescrollVue // 注册mescroll组件
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 5 //每页数据条数,默认10
        },
        htmlNodata: '<p class="upwarp-nodata">所有卡卷已经全部加载完成</p>',
        noMoreSize: 5, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: "cardList", //父布局的id (1.3.5版本支持传入dom元素)
          tip: "暂无相关卡卷数据~" //提示
        }
      },
      // 列表数据
      CardList: []
    };
  },
  created: function() {
    // this.getCardList();
  },
  methods: {
//跳转到激活卡卷
toActiveCard(){
this.$router.push('/system/activate')
},
// 给每个卡卷列表添加点击事件
pushCardDetail(cardUid){
// 跳转
this.$router.push({
  path:'/system/coupon',
  query:{cardUid:cardUid}
})
},
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      // 联网请求
      getApi({ url:"/card/list/" + page.num, query: {} })
        .then(response =>{
          console.log(response);
          // 请求的列表数据
          let arr = response.data;
          // 如果是第一页需手动置空列表
          if (page.num === 1) this.CardList = [];
          // 把请求到的数据添加到列表
          this.CardList = this.CardList.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() =>{
            mescroll.endSuccess(arr.length);
          });
        })
        .catch(e => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    }
  }
};
</script>

<style lang="less" scoped>
 .mescroll {
   box-sizing: border-box;
			    position: fixed;
			    top: 0;
			    bottom: 0;
          height: auto;
           padding:  0.32rem  0.32rem;
        }
.outer {
   box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.inner {
  padding-bottom: 0.32rem;
  box-sizing: border-box;
  width: 100%;
}
.bodyList {
  padding-top: 0.32rem;
  width: 100%;
  box-sizing: border-box;

}
.list_item {
  margin-bottom: 0.32rem;
  width: 100%;
  border-radius: 0.2rem;
  background-color: rgb(255, 255, 255);
  // box-shadow: 0rem 0rem 0.2rem rgba(33, 22, 19, 0.2);
  .list_item01 {
    overflow: hidden;
    box-sizing: border-box;
    border-bottom: 0.01rem solid rgb(238, 238, 238);
    .txt {
      font-size: 0.3rem;
      color: rgb(51, 51, 51);
      padding: 0.31rem 0rem 0.31rem 0.17rem;
    }
    .price {
      //  margin-right: 0.35rem;
      //  margin-top: 0.35rem;
      padding: 0.35rem 0.21rem 0.31rem 0;
      color: rgb(255, 0, 0);
      font-size: 0.3rem;
    }
  }

  .list_item02 {
    overflow: hidden;
    .numTxt {
      padding: 0.31rem 0rem 0.31rem 0.15rem;
      float: left;
      color: rgb(153, 153, 153);
      font-size: 0.26rem;
    }
    .priceTxt {
      padding: 0.15rem 0.24rem 0.1rem 0rem;
      float: right;
      padding-right: 0.2rem;
      color: rgb(192, 31, 31);
      font-size: 0.4rem;
    }
  }

  .list_item03 {
    .timeTxt {
      padding: 0rem 0rem 0.33rem 0.15rem;
      color: rgb(153, 153, 153);
      font-size: 0.26rem;
    }
  }
}
.bottom {
  background-color: #ffffff;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0px;
  .bottomBtn {
    width: 4rem;
    height: 0.88rem;
    margin: 0.2rem auto;
    button {
      width: 100%;
      height: 100%;
      border-radius: 0.2rem;
      font-size: 0.3rem;
      color: rgb(255, 255, 255);
      background-color: rgb(77, 205, 112);
      border: 1px solid transparent;
    }
  }
}
</style>
  
